<template>
  <div id="app">
    <div id="nav">
      <router-link to="/"><img alt="Logo E-Marketing" src="./assets/logo-white.png"></router-link>
    </div>
    <router-view/>
    <div class="contact-fabs">
      <a href="https://api.whatsapp.com/send?phone=5551996265758" target="_blank" class="fab whats">
        <img src="./assets/whatsapp.svg" alt="WhatsApp" title="Entre em contato pelo WhatsApp">
      </a>
      <a href="tel:051996265758" class="fab phone">
        <img src="./assets/telephone.svg" alt="Telefone" title="Entre em contato por telefone">
      </a>
      <a href="mailto:atendimento@emarketingbr.com.br" class="fab email">
        <img src="./assets/envelope.svg" alt="Email" title="Entre em contato por email">
      </a>
      <button v-on:click="toggleContactFABS()">
        <img src="./assets/chat-shadow.svg" alt="Entre em Contato" title="Entre em contato">
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    toggleContactFABS: function () {
      let fabs = document.getElementsByClassName('fab')
      Array.from(fabs).forEach((btn) => {
        btn.classList.toggle('visible')
      })
    }
  }
}
</script>

<style lang="scss">
body {
  background-color: rgb(51,51,51);
  /*background-color: #fff;*/
  background-image: linear-gradient(to left bottom, #362f68, #3d337f, #443697, #4d38af, #573ac7, #573ac7, #573ac7, #573ac7, #4d38af, #443697, #3d337f, #362f68);
  /*background-image: linear-gradient(to left bottom, #000000, #0e0e0e, #181818, #202020, #282828, #282828, #282828, #282828, #202020, #181818, #0e0e0e, #000000);*/
  /*background-image: linear-gradient(to left bottom, #16161f, #161629, #151633, #13153c, #121446, #1b1041, #210c3c, #260737, #260426, #210218, #17000b, #000000);*/
  /*background-image: linear-gradient(to left bottom, #16161f, #151520, #131322, #121223, #101024, #120d21, #130a1e, #14071b, #140414, #11020d, #0a0105, #000000);*/
  background-repeat: no-repeat;
  background-attachment: fixed;
  margin: 0;
}

* {
  box-sizing: border-box;
}

#app {
  font-family: 'Montserrat', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #fff;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #fff;

    img {
      width: 200px;
    }
  }
}

.contact-fabs {
  position: fixed;
  right: 10px;
  bottom: 10px;

  button {
    background: none;
    border: none;
    cursor: pointer;
    outline: none;
    padding: 0;

    img {
      width: 50px;
      height: auto;
      transition: transform 0.3s;

      &:hover {
        transform: scale(1.2);
      }
    }
  }

  .fab {
    position: fixed;
    display: block;
    background-color: #362f68;
    border-radius: 50%;
    transition: all 0.3s;
    padding: 0;
    width: 0;
    height: 0;
    right: 30px;
    bottom: 30px;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);

    &.visible {
      padding: 10px;
      width: 50px;
      height: 50px;
    }

    &:hover {
      transform: scale(1.1);
    }

    img {
      width: 100%;
      height: auto;
    }

    &.whats.visible {
      right: 5px;
      bottom: 80px;
    }

    &.phone.visible {
      right: 60px;
      bottom: 60px;
    }

    &.email.visible {
      right: 75px;
      bottom: 5px;
    }
  }
}
</style>
